"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Create default value of HtmlSanitizerOptions with every property set
 */
function createDefaultHtmlSanitizerOptions() {
    return {
        elementCallbacks: {},
        attributeCallbacks: {},
        styleCallbacks: {},
        additionalAllowedTags: [],
        additionalAllowAttributes: [],
        additionalAllowedCssClasses: [],
        additionalDefaultStyleValues: {},
        additionalGlobalStyleNodes: [],
        allowPreserveWhiteSpace: false,
    };
}
exports.default = createDefaultHtmlSanitizerOptions;
//# sourceMappingURL=createDefaultHtmlSanitizerOptions.js.map